import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, withRouter } from 'react-router-dom'
import { Row } from 'react-bootstrap'
import NewListSettings from './list-settings'
import { requestApiListSize, resetAddNewList, resetListInput } from '../../../redux/actions/new-list'
import { sendErrorNotification } from '../../universal/notifications/notifications'
import DashboardNewListRightContainer from './list-results'
import { setFallbackMessage } from '../../../redux/actions/universal'
import './style.scss'

const Index = () => {

	const dispatch = useDispatch()
	const [firstLoad, setFirstLoad] = useState(true)

	const history = useHistory()

	const filterIndustryCodes = useSelector(state => state.newList.listFilter.industryCodes)
	const filterOrganizationType = useSelector(state => state.newList.listFilter.organizationType)
	const filterLocations = useSelector(state => state.newList.listFilter.locations)
	const filterIsVatRegistered = useSelector(state => state.newList.listFilter.isVatRegistered)
	const filterInBusinessRegister = useSelector(state => state.newList.listFilter.inBusinessRegister)
	const filterInFoundationRegister = useSelector(state => state.newList.listFilter.inFoundationRegister)
	const filterRegistrationFrom = useSelector(state => state.newList.listFilter.registrationFrom)
	const filterRegistrationTo = useSelector(state => state.newList.listFilter.registrationTo)
	const filterEmployeesFrom = useSelector(state => state.newList.listFilter.employeesFrom)
	const filterEmployeesTo = useSelector(state => state.newList.listFilter.employeesTo)

	const addListError = useSelector(state => state.newList.createList.error)
	const addListStatus = useSelector(state => state.newList.createList.status)

	useEffect(() => {
		if(addListStatus){
			dispatch(resetAddNewList())
			dispatch(setFallbackMessage({type: "success", content: "Listen ble opprettet."}))
			history.push("/dashboard/lister")
		}
	}, [addListStatus])

	useEffect(() => {
		if(addListError){
			sendErrorNotification("Kunne ikke opprette ny liste.")
			dispatch(resetAddNewList())
		}
	}, [addListError])

	useEffect(() => {

		if(firstLoad){
			dispatch(requestApiListSize(null))
			setFirstLoad(false)
		}

		if(!firstLoad){
			const craftObject = {
				industryCodes: filterIndustryCodes,
				organizationType: filterOrganizationType,
				locations: filterLocations,
				isVatRegistered: filterIsVatRegistered,
				inBusinessRegister: filterInBusinessRegister,
				inFoundationRegister: filterInFoundationRegister,
				registrationFrom: filterRegistrationFrom,
				registrationTo: filterRegistrationTo,
				employeesFrom: filterEmployeesFrom,
				employeesTo: filterEmployeesTo,
			}
			dispatch(requestApiListSize(craftObject))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterIndustryCodes, filterOrganizationType, filterLocations, filterIsVatRegistered, filterInBusinessRegister, filterInFoundationRegister, filterRegistrationFrom, filterRegistrationTo, filterEmployeesFrom, filterEmployeesTo])

	useEffect(() => {
		dispatch(resetAddNewList())
		dispatch(resetListInput())
	}, [])

	return(
		<section className="dashboard-new-list-section">
			<div className="inner-dashboard-new-list-container">
				<Row className="dashboard-new-list-row">
					<NewListSettings/>
					<DashboardNewListRightContainer/>
				</Row>
			</div>
		</section>
	)
}

export default withRouter(Index)



